import React from 'react';
import { cn } from '../../lib/utils';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'slate' | 'navy';
}
export function SectionWrapper({
  children,
  className,
  id,
  background = 'white'
}: SectionWrapperProps) {
  const backgrounds = {
    white: 'bg-white',
    slate: 'bg-slate-50',
    navy: 'bg-slate-900'
  };
  return <section id={id} className={cn('py-16 md:py-24 w-full overflow-hidden', backgrounds[background], className)} data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">{children}</div>
    </section>;
}